import { motion } from "framer-motion";

export function EnergyCore() {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      {/* Halo glow */}
      <motion.div
        style={{
          position: "absolute",
          width: 120,
          height: 120,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(250,204,21,0.4) 0%, rgba(168,85,247,0.2) 100%)",
          filter: "blur(20px)",
        }}
        animate={{
          opacity: [0.3, 0.8, 0.3],
          scale: [1, 1.3, 1],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* Core sphere */}
      <motion.div
        style={{
          position: "absolute",
          width: 80,
          height: 80,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, #fff 0%, #facc15 40%, #a855f7 100%)",
          filter: "blur(4px) brightness(1.8)",
          boxShadow:
            "0 0 30px rgba(250,204,21,0.8), 0 0 60px rgba(168,85,247,0.6)",
        }}
        initial={{
          scale: 0,
          opacity: 0,
        }}
        animate={{
          scale: [0, 1.4, 1.3, 1.2, 1.0],
          opacity: [0, 1, 1, 1, 1],
        }}
        transition={{
          duration: 0.3,
          ease: "easeOut",
        }}
      />
    </div>
  );
}
